module.exports = __webpack_public_path__ + "static/media/happy-man.a91cdce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/happy-man.png
// module id = 1220
// module chunks = 2